import { render } from "./StructureTenantCard.vue?vue&type=template&id=3fda091a&scoped=true&ts=true"
import script from "./StructureTenantCard.vue?vue&type=script&lang=ts"
export * from "./StructureTenantCard.vue?vue&type=script&lang=ts"

import "./StructureTenantCard.vue?vue&type=style&index=0&id=3fda091a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fda091a"]])

export default __exports__